import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad({ context: { auth }, location, search }) {
    const { isAuthorized } = auth

    if (!location) {
      return
    }

    if (!isAuthorized) {
      const { pathname, searchStr } = location

      if (search.score != null) {
        window.localStorage.setItem('__feedbackScore', `${search.score ?? '0'}`)
      }

      const redirect_to = pathname !== '/' && search.redirect_to == null ? pathname + searchStr : undefined
      throw redirect({ to: AppRoute.Login, search: { redirect_to } })
    }
  },
})
